<template>
  <div class="home">
    <!-- <NavigatinBar></NavigatinBar> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue";
// import NavigatinBar from "@/components/NavigationBar.vue";

export default {
  name: "Home",
  components: {
    HelloWorld
    // NavigatinBar
  }
};
</script>
